export const excludedProjectFieldsForFilter = [
  'estimatedDueDate',
  'currentPhases',
];

export enum ProjectFieldIds {
  'ProjectAge' = -100006,
  'PlannedDuration' = -100007,
  'ActualStartDate' = -100008,
  'ActualCompletdDate' = -100009,
}
